import { useEffect } from "react";
import PageTitle from "../../HOC/page-title";
import CardWrapper from "../../HOC/card/card";
import SectionTitle from "../../components/section-title";
import CardHeader from "../../components/card-header";
import "./apply-request.scss";
import ApplyForm from "../../components/apply-form";




const ApplyRequest = ({ handleChangeKey }) => {
  useEffect(() => {
    handleChangeKey(7);
  }, []);
  return (
    <div className="apply-request-container">
      <CardWrapper>
           <SectionTitle title="تقديم طلب جديد" />
           <ApplyForm/>

      </CardWrapper>
    </div>
  );
};

export default PageTitle(ApplyRequest);
